enum MailListContextMenuType {
    All,
    MoveTo,
    Categorize,
    Snooze,
}

export default MailListContextMenuType;
